import { inject, Injectable } from '@angular/core';

import { SessionService } from './session.service';
import { UserService } from './user.service';

@Injectable()
export class AuthenticateService {
  private userService = inject(UserService);
  private sessionService = inject(SessionService);

  authenticate(data: any): void {
    this.sessionService.sessionId = window.localStorage.getItem('sessionId');
    this.userService.buildUserProfile(data);
  }
}
